const SafetyForm = ({ value, onChange, onSubmit, onCancel, creating }) => {
  const v = value || {};

  return (
    <form onSubmit={onSubmit} className="bg-white rounded-lg shadow p-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="text-sm text-gray-700">Date</label>
          <input
            type="date"
            value={v.observation_date || ""}
            onChange={(e) => onChange("observation_date", e.target.value)}
            className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
            required
          />
        </div>

        <div>
          <label className="text-sm text-gray-700">Type</label>
          <select
            value={v.observation_type || "observation"}
            onChange={(e) => onChange("observation_type", e.target.value)}
            className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
          >
            <option value="observation">observation</option>
            <option value="near_miss">near_miss</option>
            <option value="incident">incident</option>
            <option value="audit">audit</option>
          </select>
        </div>

        <div>
          <label className="text-sm text-gray-700">Status</label>
          <select
            value={v.status || "open"}
            onChange={(e) => onChange("status", e.target.value)}
            className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
          >
            <option value="open">open</option>
            <option value="in_progress">in_progress</option>
            <option value="closed">closed</option>
          </select>
        </div>

        <div className="md:col-span-3">
          <label className="text-sm text-gray-700">Description</label>
          <textarea
            value={v.description || ""}
            onChange={(e) => onChange("description", e.target.value)}
            rows={3}
            className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
            required
          />
        </div>

        <div>
          <label className="text-sm text-gray-700">Category</label>
          <input
            value={v.category || "general"}
            onChange={(e) => onChange("category", e.target.value)}
            className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
          />
        </div>

        <div>
          <label className="text-sm text-gray-700">Location</label>
          <input
            value={v.location || ""}
            onChange={(e) => onChange("location", e.target.value)}
            className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
          />
        </div>

        <div className="md:col-span-3">
          <label className="text-sm text-gray-700">Action Taken</label>
          <textarea
            value={v.action_taken || ""}
            onChange={(e) => onChange("action_taken", e.target.value)}
            rows={2}
            className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
          />
        </div>
      </div>

      <div className="flex items-center gap-3">
        <button
          type="submit"
          disabled={creating}
          className="px-4 py-2 rounded-md bg-gray-900 text-white text-sm font-medium hover:bg-black disabled:opacity-60"
        >
          {creating ? "Creating..." : "Create"}
        </button>

        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 rounded-md bg-gray-100 text-gray-800 text-sm font-medium hover:bg-gray-200"
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default SafetyForm;
